<template>
  <div v-show="visible" class="toast-container">
    <div ref="toast" class="toast" :style="{ '--radius': '24px' }" @mouseover="clearTimer" @mouseleave="onMouseLeave">
      <span>{{ $t(message, { default: message }) }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { nextTick, ref, watch } from 'vue'
  import { INSTANCE as ToastManager } from '@/core/ToastManager'

  const DURATION_AUTO_CLOSE = 5000
  const timer = ref()
  const visible = ref(false)
  const message = ref('')
  const toast = ref<HTMLDivElement>()

  ToastManager.setListener({
    onShow(text: string) {
      message.value = text
      visible.value = true
      close()
    },
    onHide() {
      visible.value = false
    },
  })

  const clearTimer = () => {
    if (timer.value) clearTimeout(timer.value)
  }

  const onMouseLeave = () => {
    close()
  }

  const close = () => {
    timer.value = setTimeout(() => {
      ToastManager.hide()
    }, DURATION_AUTO_CLOSE)
  }

  watch(visible, (newVisible) => {
    if (newVisible) {
      nextTick(() => {
        if (toast.value) {
          toast.value.style.setProperty('--radius', toast.value.clientHeight / 2 + 'px')
        }
      })
    }
  })
</script>
<style scoped lang="stylus">

  .toast-container
    position absolute
    bottom 88px
    z-index $zIndexToast
    width 100%
    flex-all-center()
  .toast
    box-sizing border-box
    text-align left
    gap 10px
    min-width 188px
    max-width 310px
    padding 14px 17.5px
    min-height 56px
    background rgba(255, 255, 255, 0.8)
    border 0.33px solid rgba(0, 0, 0, 0.12)
    box-shadow 0px 6px 20px rgba(0, 0, 0, 0.08)
    backdrop-filter blur(30px)
    border-radius 12px
    font-weight bolder_font_weight
    font-size 14px
    color default_color
    line-height normal
    display flex
    justify-content center
    align-items center

  @import '../styles/h5Adaptive/ToastInfo.styl'
</style>
